<script lang="ts" setup>
const { getMetaAttributes, getTechnologyAttributes } = useApiAttributes()
const { t } = useI18n()
const api = useApi()

const { data: response, execute, status } = useAsyncData(
  'doc:technologies-search',
  () => api.technologies.fetch(),
  { immediate: false },
)

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/technologies',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.page'),
    example: '/technologies?page=1',
    name: 'page',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.search'),
    example: '/technologies?search=shopify',
    name: 'search',
    optional: true,
    type: 'string',
  },
  {
    description: t('attributes.size'),
    example: '/technologies?size=10',
    name: 'size',
    optional: true,
    type: 'number',
  },
]

const responseAttributes: ApiAttribute[] = [
  {
    attributes: getTechnologyAttributes(),
    description: t('response.technologies'),
    name: 'technologies',
    type: 'array',
  },
  getMetaAttributes(),
]

async function onVisibilityChange(visibility: boolean) {
  if (visibility && !response.value) {
    await execute()
  }
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :loading="status === 'pending'"
    :query-attributes="queryAttributes"
    :response="response?.data"
    :response-attributes="responseAttributes"
    @visibility-change="onVisibilityChange"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "page": "The page to fetch (default to 1).",
      "search": "An additional search query applied to the technology name.",
      "size": "The number of technology to be returned (between 1 and 100). Default to 25."
    },
    "response": {
      "technologies": "The technologies we identify that match your conditions."
    }
  },
  "es": {
    "attributes": {
      "page": "La página a recuperar (por defecto 1).",
      "search": "Una consulta de búsqueda adicional aplicada al nombre de la tecnología.",
      "size": "El número de tecnologías a devolver (entre 1 y 100). Por defecto 25."
    },
    "response": {
      "technologies": "Las tecnologías que identificamos que coinciden con tus condiciones."
    }
  },
  "fr": {
    "attributes": {
      "page": "La page à récupérer (par défaut 1).",
      "search": "Une requête de recherche supplémentaire appliquée au nom de la technologie.",
      "size": "Le nombre de technologies à renvoyer (entre 1 et 100). Par défaut 25."
    },
    "response": {
      "technologies": "Les technologies que nous identifions qui correspondent à vos conditions."
    }
  }
}
</i18n>
